module.exports = __webpack_public_path__ + "img/data@8x.dd541f57.png";